import ApiUtils from "../ApiUtils";

export default class ApiClassPromotionService {

    async findEmailCampaigns(data) {
        return await ApiUtils.callApi(`promotion/email/campaign/search`,'post',data);
    }

    async changeEmailCampaignStatus(campaignId,status) {
        return await ApiUtils.callApi(`promotion/email/campaign/status/${campaignId}/${status}`,'patch');
    }

    async getUpcomingClass(companyId,classType) {
        return await ApiUtils.callApi(`promotion/classes/${companyId}/${classType}`,'get');
    }

    async sendCampaignTestEmail(data) {
        return await ApiUtils.callApi(`promotion/template/test/email`,'post',data);
    }

    async previewTemplate(data) {
        return await ApiUtils.callApi(`promotion/template/preview`,'post',data);
    }

    async createEmailCampaign(data) {
        return await ApiUtils.callApi(`promotion/email/campaign/save`,'post',data);
    }

    // Email template manage api
    async findTemplate(data) {
        return await ApiUtils.callApi(`email/tool/customize/find`,'post',data);
    }

    async saveTemplate(data) {
        return await ApiUtils.callApi(`email/tool/customize/save`,'post',data);
    }
}
